// extracted by mini-css-extract-plugin
module.exports = {"className":"textInspirationalTitleXXXL_className___5TU4"};